// const URL = `http://localhost:8080`;
// const URL = `https://ocatest.universalec.com.tw/api`;
const URL = 'https://permit.oac.gov.tw/api';

const DOC_TPYES = {
    OAC1: '海洋野生動物活體輸入同意書',
    OAC2: '海洋野生動物活體輸出(再輸出)同意書',
    OAC3: '海洋野生動物產製品輸入同意書',
    OAC4: '海洋野生動物產製品輸出(再輸出)同意書'
}

const ACCOUNT = {
    REGISTER_ACCOUNT: 'REGISTER_ACCOUNT',
    REGISTER_ACCOUNT_LOAD: 'REGISTER_ACCOUNT_LOAD',
    REGISTER_ACCOUNT_SUCCESS: 'REGISTER_ACCOUNT_SUCCESS',
    REGISTER_ACCOUNT_FAIL: 'REGISTER_ACCOUNT_FAIL',
};

const AUTH = {
    FETCH_CAPTCHA: 'FETCH_CAPTCHA',
    FETCH_CAPTCHA_LOAD: 'FETCH_CAPTCHA_LOAD',
    FETCH_CAPTCHA_SUCCESS: 'FETCH_CAPTCHA_SUCCESS',
    FETCH_CAPTCHA_FAIL: 'FETCH_CAPTCHA_FAIL',

    LOGIN: 'LOGIN',
    LOGIN_LOAD: 'LOGIN_LOAD',
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGIN_FAIL: 'LOGIN_FAIL',

    LOGOUT: 'LOGOUT'

};

const FUNCTION = {
    FUNCTION_QUERY: "FUNCTION_QUERY",
    FUNCTION_QUERY_SUCCESS: "QUERY_SUCCESS",
    FUNCTION_QUERY_LOAD: "QUERY_LOAD"
}


const SYSTEM = {
    GROUP_QUERY: "GROUP_QUERY",
    GROUP_QUERY_SINGLE: "GROUP_QUERY_SINGLE",
    QUERY_SUCCESS: "QUERY_SUCCESS",
    QUERY_LOAD: "QUERY_LOAD"
}

const BIDCASEREVIEW = {
    BIDCASEREVIEW_QUERY: "BIDCASEREVIEW_QUERY",
    BIDCASEREVIEW_QUERY_SUCCESS: "BIDCASEREVIEW_QUERY_SUCCESS",
    BIDCASEREVIEW_QUERY_LOAD: "BIDCASEREVIEW_QUERY_LOAD"
}

const IE_TYPE = {
    1: '輸入',
    2: '輸出',
    3: '再輸出'
}

const EDITOR_CONFIG = {
    toolbar: ['heading', '|', 'bold', 'italic', '|', 'link', 'bulletedList', 'numberedList', 'blockQuote'],
    heading: {
        options: [
            { model: 'paragraph', title: '段落', class: 'ck-heading_paragraph' },
            { model: 'heading1', view: 'h1', title: '標題一', class: 'ck-heading_heading1' },
            { model: 'heading2', view: 'h2', title: '標題二', class: 'ck-heading_heading2' }
        ]
    }
}

export const TRIGGER_PERIOD = {
    Y: '年',
    M: '月',
    W: '週',
    D: '日'
}

export const ACCESS_TYPE = {
    1: '查詢',
    2: '新增',
    3: '修改',
    4: '刪除',
    5: '列印',
    6: '匯出',
    7: '匯入',
    8: '下載',
    9: '退回',
    A: '暫存',
    B: '送出'
}

export const CHANGE_LOG_STATUS = {
    1: '新增',
    2: '修改',
    3: '刪除',
    9: '其他'
}

export { URL, ACCOUNT, AUTH, SYSTEM, FUNCTION, BIDCASEREVIEW, DOC_TPYES, IE_TYPE, EDITOR_CONFIG };

